// The sidebar lives in ./sidebar, split by concern; this keeps its import path.
export { default } from "@/components/sidebar/Sidebar";
